import { useLang } from "@/i18n/LanguageContext";
import { Columns3, ShieldCheck, Zap } from "lucide-react";

const VALUE_ICONS = [Columns3, ShieldCheck, Zap];

const Studio = () => {
  const { t } = useLang();
  return (
    <div className="section-content section-enter" data-testid="section-studio">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-8 lg:gap-14 items-start stagger">
          <div className="col-span-12 lg:col-span-5">
            <div className="eyebrow">01 · {t.nav.studio}</div>
            <h2
              className="display mt-4"
              style={{ fontSize: "clamp(2rem, 4vw, 3.4rem)" }}
              data-testid="studio-title"
            >
              {t.studio.title}
            </h2>
            <div
              className="mt-4"
              style={{
                fontFamily: "'PT Sans', sans-serif",
                fontStyle: "italic",
                fontSize: "clamp(1rem, 1.4vw, 1.25rem)",
                color: "var(--ink)",
                fontWeight: 700,
              }}
            >
              {t.slogan.split(" · ").map((part, i, arr) => (
                <span key={i}>
                  <span>{part}</span>
                  {i < arr.length - 1 && <span style={{ color: "var(--accent-dark)", margin: "0 0.4em" }}>·</span>}
                </span>
              ))}
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <div className="space-y-3.5">
              {t.studio.paragraphs.map((p, i) => (
                <p
                  key={i}
                  data-testid={`studio-paragraph-${i}`}
                  style={{
                    color: "var(--ink-mute)",
                    fontSize: "15.5px",
                    lineHeight: 1.7,
                    textAlign: "justify",
                  }}
                >
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
              {t.studio.values.map((v, i) => {
                const Icon = VALUE_ICONS[i];
                return (
                <div
                  key={v.k}
                  data-testid={`studio-value-${i}`}
                  style={{
                    background: "var(--paper)",
                    borderRadius: 14,
                    border: "1px solid var(--cream-edge)",
                    padding: "18px 18px 20px",
                  }}
                >
                  <div className="flex items-center justify-between">
                    <div className="label" style={{ color: "var(--accent-dark)" }}>
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    {Icon && (
                      <div
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 10,
                          border: "1.5px solid var(--accent-dark)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <Icon size={20} strokeWidth={1.6} style={{ color: "var(--accent-dark)" }} />
                      </div>
                    )}
                  </div>
                  <h3
                    className="heading mt-2"
                    style={{ fontSize: "clamp(1.15rem, 1.4vw, 1.35rem)", fontFamily: "'Cinzel', serif" }}
                  >
                    {v.k}
                  </h3>
                  <p
                    className="mt-2"
                    style={{
                      color: "var(--ink-mute)",
                      fontSize: "13.5px",
                      lineHeight: 1.6,
                    }}
                  >
                    {v.d}
                  </p>
                </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Studio;
